// extracted by mini-css-extract-plugin
export default {"container":"brands_container__zaZtG","grid":"brands_grid__mgmea","panel":"brands_panel__4Z9eN","brandsTable":"brands_brandsTable__FSWPU","staffTable":"brands_staffTable__NiPfN"};